<script>
import AppForm from '../components/AppForm';
import getFieldErrors from '../getFieldErrors';
import ChallengeLoader from '../components/ChallengeLoader';

export default {
  name: 'SignatureFrejaId',
  components: {
    AppForm,
    ChallengeLoader,
  },
  data() {
    return {
      fieldErrors: {},
      userInstructions: undefined,
      signingProcess: {},
    }
  },
  computed: {
    inputValues() {
      return this.$root.$options.storeGetters.inputValues();
    },
    signatureIsProcessing() {
      return this.$root.$options.storeGetters.signatureIsProcessing();
    },
    additionalMethodConfig() {
      return this.$root.$options.storeGetters.additionalMethodConfig();
    },
    countryCode() {
      return this.$root.$options.storeGetters.countryCode();
    },
    schema() {
      return [
        {
          type: 'text',
          name: 'idcode',
          label: this.$t('idcode'),
          placeholder: this.$t(this.countryCode.toLowerCase() + '-freja-id-code-placeholder'),
          validation: ['required'],
        },
        {
          type: 'submit',
          label: this.$t('Sign')
        }
      ]
    },
    formValue: {
      get() {
        return {
          idcode:  this.inputValues.idcode,
        }
      },
      set(newValues) {
        this.updateInputValues(newValues);
      }
    },
  },
  methods: {
    updateInputValues(newValues) {
      this.$root.$options.storeActions.updateInputValues(newValues);
    },
    loadingStart() {
      this.$root.$options.storeActions.loadingStart();
    },
    loadingEnd() {
      this.$root.$options.storeActions.loadingEnd();
    },
    addFlashMessage(message) {
      this.$root.$options.storeActions.addFlashMessage(message);
    },
    clearFlashMessages() {
      this.$root.$options.storeActions.clearFlashMessages();
    },
    startSignatureProcessing() {
      this.$root.$options.storeActions.startSignatureProcessing();
    },
    endSignatureProcessing() {
      this.$root.$options.storeActions.endSignatureProcessing();
    },
    clearErrors() {
      this.fieldErrors = {};
    },
    cancel() {
      const {cancel} = this.signingProcess;
      if (cancel) {
        cancel();
      }
    },
    sign() {
      this.loadingStart();
      this.clearFlashMessages();
      this.clearErrors();

      const dataToSubmit = {
        ...this.formValue,
      };
      const additionalMethodConfig = this.additionalMethodConfig || {};
      this.signingProcess = this.$root.$options.eidEasyClient.signature.frejaSimpleSignature.start({
        ...dataToSubmit,
        started: () => {
          this.userInstructions = this.$t('approve-sign-request-on-freja-app');
          this.startSignatureProcessing();
          this.loadingEnd();
        },
        fail: (error) => {
          if (!error.isCancel) {
            this.addFlashMessage(error);
          }
          this.fieldErrors = getFieldErrors(error);
          this.$root.$options.eidEasyOnFail(error);
        },
        success: (result) => {
          this.$root.$options.eidEasyOnSuccess(result);
        },
        finished: () => {
          this.userInstructions = undefined;
          this.endSignatureProcessing();
          this.loadingEnd();
        },
        ...additionalMethodConfig,
      });
    }
  },
}
</script>

<template>
  <div :class="$style.formContainer">
    <div
      v-if="userInstructions"
      :class="$style.userInstructions"
    >
      <ChallengeLoader :user-instructions="userInstructions" />
    </div>
    <div v-else>
      <AppForm
        id="frejaSignatureIdForm"
        v-model="formValue"
        :schema="schema"
        :on-submit="sign"
        :errors="fieldErrors"
      />
    </div>
  </div>
</template>

<style lang="scss" module>
.formContainer {
  max-width: $form-container-width;
  margin: 0 auto;
}
</style>
